module.exports = __webpack_public_path__ + "img/dots_rub_3.56588536.png";